import type { TextLevel } from "../../../../../../mads/Text/TextLevel";

import { Heading } from "../../../../../../mads";

import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet, type TextProps } from "react-native";

export interface JobTitleProps {
  jobTitle: string;
  level?: TextLevel;
  compact?: boolean;
  ellipsizeMode?: TextProps["ellipsizeMode"];
  numberOfLines?: number;
  testID?: string;
}

/**
 * This is the simplified jobtitle without company logo
 */
export function JobTitle(props: JobTitleProps) {
  return (
    <Heading
      ellipsizeMode={props.ellipsizeMode}
      level={props.level}
      numberOfLines={props.numberOfLines}
      sx={props.compact ? styles.compact : styles.default}
      testID={props.testID ?? "vj-job-title"}
    >
      {props.jobTitle}
    </Heading>
  );
}

const styles = StyleSheet.create({
  compact: {
    color: colors.neutral["1000"],
    flexShrink: 1,
    marginBottom: 0,
    marginTop: 0,
    minWidth: 0,
    paddingVertical: 4,
  },
  default: {
    color: colors.neutral["1000"],
    marginBottom: 8,
    marginTop: 0,
  },
});
